import React from 'react';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import CarEstimatePanel from 'desktop/components/CarEstimatePanel/CarEstimatePanel';
import s from './CarCostEstimate.css';

class CarCostEstimate extends React.Component {
  static propTypes = {};
  static defaultProps = {};

  render() {
    return (
      <div className={s.root}>
        <span className={s.title}>
          <FormattedMessage id={'Оценка стоимости авто'} />
        </span>
        <CarEstimatePanel isHome />
      </div>
    );
  }
}

export default withStyles(s)(CarCostEstimate);



// WEBPACK FOOTER //
// ./src/desktop/routes/home/components/CarCostEstimate/CarCostEstimate.js